// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".detailpage-layout[data-v-470d32da]{z-index:202}.main-app-bar[data-v-470d32da]{z-index:3!important}.disable-link[data-v-470d32da]{cursor:default!important}.back-btn--absolute[data-v-470d32da]{left:50px;position:absolute;top:50px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
